import { type FaqsTypeFront } from '@/src/Types/Blocks/Faqs';

import Decorations from '../../_components/Decorations';
import { getBtnSettingsToCSS } from '../../_lib/btns';
import FaqsBlock from './variants/Block';
import FaqsClassic from './variants/Classic';

type FaqsProps = Omit<FaqsTypeFront, 'block_theme'>;

export const Faqs = (props: FaqsProps) => {
	const {
		variant = 'classic',
		containerType = 'wide',
		headingAlign = 'center',
		style,
		context = 'faqs',
		ctasStyle,
		placement,
		sectionDecoration,
		id,
	} = props;

	const FaqsTypeModel: FaqsTypeFront = {
		id: props.id,
		title: props.title,
		description: props.description,
		titleFormat: props.titleFormat,
		posts: props.posts,
		containerType: containerType,
		variant: variant,
		headingAlign: headingAlign,
		archiveLink: props.archiveLink,
		linkIndex: props.linkIndex,
		context: context,
		archiveLinkStyles: props.archiveLinkStyles,
		sectionDecoration: sectionDecoration,
		headingFontClassName: {
			title: 'minos-faqs-heading-title-font-style tablet:minos-faqs-heading-title-font-style',
			text: {
				p: 'minos-faqs-heading-description-font-style text-base tablet:minos-faqs-heading-description-font-style mb-5 tablet:mb-6 last:mb-0',
				a: getBtnSettingsToCSS(ctasStyle, 'a', context),
				btnPrimary: getBtnSettingsToCSS(ctasStyle, 'primary', context),
				btnSecondary: getBtnSettingsToCSS(ctasStyle, 'secondary', context),
				btnTertiary: getBtnSettingsToCSS(ctasStyle, 'tertiary', context),
			},
		},
		contentFontClass: {
			title: 'minos-faqs-inside-title-font-style text-2xl tablet:minos-faqs-inside-title-font-style',
			text: {
				p: 'minos-faqs-content-p text-base tablet:minos-faqs-content-p mb-5 tablet:mb-6',
				h1: 'minos-faqs-content-h1 text-4xl tablet:minos-faqs-content-h1 mb-5 tablet:mb-6',
				h2: 'minos-faqs-content-h2 text-3xl tablet:minos-faqs-content-h2 mb-4 tablet:mb-4',
				h3: 'minos-faqs-content-h3 text-2xl tablet:minos-faqs-content-h3 mb-3 tablet:mb-3.5',
				h4: 'minos-faqs-content-h4 text-xl tablet:minos-faqs-content-h4 mb-2 tablet:mb-3',
				h5: 'minos-faqs-content-h5 text-xl tablet:minos-faqs-content-h5 mb-2 tablet:mb-3',
				h6: 'minos-faqs-content-h6 text-xl tablet:minos-faqs-content-h6 mb-2 tablet:mb-3',
				a: getBtnSettingsToCSS(ctasStyle, 'a', context),
				btnPrimary: getBtnSettingsToCSS(ctasStyle, 'primary', context),
				btnSecondary: getBtnSettingsToCSS(ctasStyle, 'secondary', context),
				btnTertiary: getBtnSettingsToCSS(ctasStyle, 'tertiary', context),
			},
		},
	};

	const variations = {
		classic: <FaqsClassic {...FaqsTypeModel} />,
		block: <FaqsBlock {...FaqsTypeModel} />,
	};

	return (
		<>
			<section id={id} className='relative' data-variant={`faqs-${variant}`} style={style}>
				<Decorations
					isSectionDecorated={sectionDecoration?.isSectionDecorated}
					type={sectionDecoration?.type}
					pathClassName={`${sectionDecoration?.type === 'wave' ? 'fill-minos-faqs-bg-color' : 'fill-minos-decoration-bubble-left'}`}
					pathClassNameRightCircle={`${sectionDecoration?.type === 'bubble' && 'fill-minos-decoration-bubble-right'}`}
					placement={placement}
				>
					{variations[props.variant]}
				</Decorations>
			</section>
		</>
	);
};

export default Faqs;
